// import Swiper bundle with all modules installed
import Swiper from 'swiper/bundle';

// import styles bundle
import 'swiper/css/bundle';

export default function swiperDemoInit() {
  const elSliders = document.querySelectorAll('.swiper-testimonial');
  const sliders = [];

  elSliders.forEach((el) => {
    const swiper = new Swiper(el, {
      spaceBetween: 60,
      slidesPerView: 1.5,
      centeredSlides: true,
      loop: true,
      autoplay: {
        delay: 6000,
        disableOnInteraction: true,
      },
      roundLengths: true,
      pagination: {
        el: '.swiper-pagination',
      },
      breakpoints: {
        // when window width is >= 1024px
        768: {
          spaceBetween: 80,
        },
        // when window width is >= 1024px
        1024: {
          spaceBetween: 120,
          slidesPerView: 2,
        }
      }
    });

    sliders.push(swiper);
  });
}
